const scope = typeof globalThis !== 'undefined'
	? globalThis
	: typeof window !== 'undefined'
		? window
		: typeof self !== 'undefined'
			? self
			: {};

const userConfig = scope.EPIC_NETWORK_CONFIG || {};
const DEFAULT_HEALTHCHECK_URL = () => `/api/health/api/?_=${Date.now()}`;

const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const deepMerge = (target, source) => {
	const output = isPlainObject(target) ? { ...target } : {};

	if (!isPlainObject(source)) return output;

	Object.keys(source).forEach(key => {
		const sourceValue = source[key];
		const targetValue = output[key];

		if (isPlainObject(sourceValue) && isPlainObject(targetValue)) {
			output[key] = deepMerge(targetValue, sourceValue);
			return;
		}

		output[key] = sourceValue;
	});

	return output;
};

const normalizeNumber = (value, fallback) => {
	const parsed = Number(value);

	return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const normalizePositiveInteger = (value, fallback) => {
	const normalized = normalizeNumber(value, fallback);

	return Math.max(1, Math.round(normalized));
};

const defaultOfflineOptions = {
	checkOnLoad:        false,
	interceptRequests:  true,
	requests:           false,
	reconnect:          true,
	checks:             {
		xhr: {
			url:     DEFAULT_HEALTHCHECK_URL,
			type:    'GET',
			timeout: 5000
		},
		active: 'xhr'
	}
};

const userOfflineOptions = isPlainObject(userConfig.offline) ? userConfig.offline : {};

const config = {
	pullErrorThreshold:        normalizeNumber(userConfig.pullErrorThreshold, 3),
	pullErrorWindow:           normalizeNumber(userConfig.pullErrorWindow, 15000),
	networkEventThreshold:     normalizePositiveInteger(userConfig.networkEventThreshold, 2),
	networkEventWindow:        normalizeNumber(userConfig.networkEventWindow, 8000),
	networkEventOfflineWeight: normalizePositiveInteger(userConfig.networkEventOfflineWeight, 1),
	offline:                   deepMerge(defaultOfflineOptions, userOfflineOptions)
};

export default config;
